import React from 'react';
import { localizationService } from '@shared-services/localization-service';
import { Booking } from '../../types';
import { BookingDataView, BookingDataViewType } from './BookingDataView';

const getString = (key: string) => {
    return localizationService.str(
        `ui.runtimessr.calbooking.confirmation.success.${key}`
    );
};
interface BookingConfirmationProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    setCancelBookingId: (bookingId: string) => void;
}

const BookingConfirmation = ({
    confirmationData,
    closeConfirmation,
    rescheduleBooking,
    setCancelBookingId,
}: BookingConfirmationProps) => {
    return (
        <BookingDataView
            bookingData={confirmationData}
            dataAuto='booking-confirmation-screen'
            onClose={closeConfirmation}
            type={BookingDataViewType.SUCCESS}
            title={getString('title')}
            svgIcon={
                <svg viewBox='0 0 24 24'>
                    <polyline points='4 12 10 18 20 6' />
                </svg>
            }
        >
            <label>{getString('change')}</label>
            <span onClick={rescheduleBooking}>{getString('reschedule')}</span>
            <label>or</label>
            <span
                onClick={() => {
                    setCancelBookingId(confirmationData.uid);
                    closeConfirmation();
                }}
            >
                {getString('cancel')}
            </span>
        </BookingDataView>
    );
};

export default BookingConfirmation;
